import { useContext } from 'react';
import { SiteContentContext } from '../context/SiteContentContext';
import { useSeo } from '../hooks/useSeo';
import '../styles/fleet_page.css';

const PersonalDataPage = () => {
  useSeo({
    title: 'Обработка персональных данных',
    description: 'Согласие на обработку персональных данных — парусная школа The Sailing Doctor.',
  });
  const { content } = useContext(SiteContentContext);

  return (
    <main className="fleet-page">
      <section className="fleet-page-hero">
        <h1>Обработка персональных данных</h1>
      </section>
      <div className="privacy-body">
        {(content.personalDataText || '').split('\n').map((line, i) => {
          if (!line.trim()) return <br key={i} />;
          const isHeading = /^\d+\./.test(line.trim()) || (line.trim() === line.trim().toUpperCase() && line.trim().length > 3);
          return isHeading
            ? <h2 key={i}>{line}</h2>
            : <p key={i}>{line}</p>;
        })}
      </div>
    </main>
  );
};

export default PersonalDataPage;
